export default __webpack_public_path__ + "static/media/Becca.dffe63f6.png";